exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".successTextColor[data-v-0c920cc8]{color:var(--tagSuccessText)}.infoText[data-v-0c920cc8]{color:var(--tagInfoText)}", ""]);

// exports
